import type { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import type { HelmetProps } from './types'
import styles from './Helmet.module.scss'

const SITE = 'https://www.engineeringgroup.am'
const BRAND = 'ENGINEERING GROUP'

const HelmetLayout: FC<HelmetProps> = ({ children, title, description, seoTitle, seoDescription }) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const pageTitle = seoTitle
    ? t(seoTitle)
    : title === 'home'
    ? `${BRAND} — ${t('whyChooseUsSubtitle')}`
    : `${t(title)} | ${BRAND}`
  const desc = t(seoDescription || description || 'aboutUsText')
  const url = `${SITE}${pathname}`

  return (
    <div className={styles.wrapper}>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name='description' content={desc} />
        <link rel='canonical' href={url} />
        <meta property='og:title' content={pageTitle} />
        <meta property='og:description' content={desc} />
        <meta property='og:url' content={url} />
        <meta name='twitter:title' content={pageTitle} />
        <meta name='twitter:description' content={desc} />
      </Helmet>
      {children}
    </div>
  )
}

export default HelmetLayout
